import { useEffect } from "react";

/**
 * usePageMeta - lightweight, dependency-free per-route document metadata.
 *
 * Sets the document <title> and <meta name="description"> for a page and
 * restores the previous values on unmount, so SPA navigation keeps the browser
 * tab title and (JS-rendered) crawler metadata correct per route.
 *
 * NOTE: Link-preview crawlers (Facebook, X, LinkedIn, Slack, iMessage) do not
 * execute JS - those rely on the static tags in public/index.html. This hook
 * improves in-app UX and search engines that render JS (e.g. Google).
 *
 * @param {{ title?: string, description?: string }} meta
 */
export default function usePageMeta({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const descEl = description
      ? document.querySelector('meta[name="description"]')
      : null;
    const prevDesc = descEl ? descEl.getAttribute("content") : null;
    if (descEl && description) descEl.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== null) descEl.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
